module.exports = __webpack_public_path__ + "static/media/mt.dbda344d.svg";